import { render, staticRenderFns } from "./AcceptanceFilesList.vue?vue&type=template&id=6db3c6bf&scoped=true"
import script from "./AcceptanceFilesList.vue?vue&type=script&lang=js"
export * from "./AcceptanceFilesList.vue?vue&type=script&lang=js"
import style0 from "./AcceptanceFilesList.vue?vue&type=style&index=0&id=6db3c6bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db3c6bf",
  null
  
)

export default component.exports